import { AgreementType, DocumentNameType } from './types';

export const isLinkAgreementType = (agreementTypeId: AgreementType) => [AgreementType.CSA, AgreementType.CLEARED_DERIVATIVES_EXECUTION_AGREEMENT, AgreementType.IM_CSA, AgreementType.ACCOUNT_CONTROL_AGREEMENT, AgreementType.MCA].includes(agreementTypeId);
export const isISDAFamilyAgreementType = (agreementTypeId: AgreementType) => [AgreementType.CSA, AgreementType.CLEARED_DERIVATIVES_EXECUTION_AGREEMENT, AgreementType.IM_CSA, AgreementType.ACCOUNT_CONTROL_AGREEMENT, AgreementType.MCA, AgreementType.ISDA].includes(agreementTypeId);

export const isCDMDocumentName = (documentNameId: DocumentNameType) => [
    DocumentNameType.ISDA_1987,
    DocumentNameType.ISDA_1992,
    DocumentNameType.ISDA_2002,
    DocumentNameType.NY_LAW_CSA_1994,
    DocumentNameType.ENGLISH_LAW_CSA_1995,
    DocumentNameType.NY_LAW_VM_CSA,
    DocumentNameType.ENGLISH_LAW_VM_CSA,
    DocumentNameType.NY_2016_IM_CSA,
    DocumentNameType.ENGLISH_2016_IM_CSD,
    DocumentNameType.NY_2018_IM_CSA,
    DocumentNameType.ENGLISH_2018_IM_CSD,
    DocumentNameType.GMRA_1995,
    DocumentNameType.GMRA_2000,
    DocumentNameType.GMRA_2011,
    DocumentNameType.GMSLA_2000,
    DocumentNameType.GMSLA_2010
].includes(documentNameId);
